// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"a2985f7e","23":"24c0f0d6","225":"c635a2ea","255":"b20b591c","328":"8a50595d","367":"8b80a77b","374":"0e5ff0f3","586":"b57792c3","704":"2addc683","750":"9eba94a3","781":"e6ee1537","857":"a9d28143"}[chunkId] + ".chunk.js";
};